<div class="px-3 py-2">
	<h4 align="center">LA DE CIFRIS INCONTRA MILANO</h4>
	<p>Il giorno <b>11 settembre 2018</b> si è tenuta una nuova sessione 
		a Milano della costituenda associazione nazionale di crittografia 
		De Componendis Cifris.</p>
	<p>Questa sessione è la seconda delle tre sessioni territoriali del 2018.</p>
	<p><b>Luogo: Università degli Studi di Milano-Bicocca - Aula Massa, 
		Edificio U6, quarto piano</b></p>
	<p>L'incontro si propone di offrire una panoramica sulle attività di ricerca 
		in Lombardia, riguardanti la Crittografia e le sue applicazioni. È stata 
		inoltre l'occasione per presentare l'iniziativa Nazionale "De Componendis 
		Cifris" che organizza l'evento.</p>
	<p>L'iniziativa De Cifris di aggregazione delle competenze di Crittografia vuole 
		stimolare la collaborazione in ambito crittografico, coinvolgendo sia le 
		numerose eccellenze accademiche, che sono tuttora presenti in Italia, sia il
		mondo delle aziende che operano nel settore.</p>
	<p><a href="../../../../assets/eventi/2018/Milano/Locandina.pdf">Locandina</a></p>
	<h5>PROGRAMMA</h5>
	<ul>
		<li><p><b>10:30 - 10:50  Registrazione partecipanti</b></p></li>
		<li>
			<p><b>10:50 - 11:50  Sessione I</b></p>
			<ul class="ulSon">
				<li>
					<p>10:50 Prof. Danilo Porro<br>
						<i style="color: green;">Pro-Rettore alla Valorizzazione della Ricerca</i><br>
						Università di Milano-Bicocca
					</p>
				</li>
				<li>
					<p>11:10 Prof. Massimiliano Sala	<br>
						<i style="color: green;">Acting Director</i> <br>
						De Componendis Cifris -- <a href="../../../../assets/eventi/2018/Milano/DeCifris_Sept2018.pdf">Slide</a>
					</p>
				</li>
				<li>
					<p>11:30 Dott. Paolo Ciocca <br>
						<i style="color: green;">Commissario della Commissione 
						Nazionale per le Società e la Borsa</i> <br>
						Consob
					</p>
				</li>
			</ul>
		</li>
		<li><p><b>11:50 - 12:15  Break</b></p></li>
		<li>
			<p><b>12:15 - 13:00  Sessione II</b></p>
			<ul class="ulSon">
				<li>
					<p>
						12:15 Prof. Alberto Leporati -- Università di Milano-Bicocca<br>
						<a href="../../../../assets/eventi/2018/Milano/Slide_AlbertoLeporati.pdf">Blockchains, and the search for Cryptographic Boolean Functions</a>
					</p>
				</li>
				<li>
					<p>
						12:30 Prof.ssa Francesca Dalla Volta - Università di Milano-Bicocca <br>
						<a href="../../../../assets/eventi/2018/Milano/Slide_FrancescaDallaVolta.pdf">Some Mathematical Topics in Symmetric Ciphers</a>
					</p>
				</li>
				<li>
					<p>
						12:45 Dott. Tommaso Pellizzari, Dott. Simone Pintus - Unicredit <br>
						<a>Blockchain Technology - Opportunità e rischi</a>
					</p>
				</li>
			</ul>
		</li>
		<li>
			<p><b>13:45 - 15:00  Sessione III</b></p>
			<ul class="ulSon">
				<li>
					<p>13:45 Dott. Andrea Visconti <br>
						Università degli Studi di Milano <br>
						<a href="../../../../assets/eventi/2018/Milano/Slide_AndreaVisconti.pdf">
							Blockchain, White-box and High-speed Cryptography</a>
					</p>
				</li>
				<li>
					<p>14:00 Dott. Ottavio Giulio Rizzo	<br>
						Università degli Studi di Milano <br>
						<a href="../../../../assets/eventi/2018/Milano/Slide_OttavioGiulioRizzo.pdf">
							Logaritmo discreto: perché è difficile attaccarlo?</a>
					</p>
				</li>
				<li>
					<p>14:15 Prof. Gerardo Pelosi <br> 
						Politecnico di Milano	<br>
						<a href="../../../../assets/eventi/2018/Milano/Slide_GerardoPelosi.pdf">Praticamente 
							resistente: realizzare crittografia protetta da attacchi side-channel</a>
					</p>
				</li>
				<li>
					<p>14:30 Dott. Alessandro Barenghi <br> 
						Politecnico di Milano	<br>
						<a href="../../../../assets/eventi/2018/Milano/Slide_AlessandroBarenghi.pdf">Crittografia 
							nell'era del calcolo quantistico: direzioni nella progettazione e realizzazione 
							di crittosistemi</a>
					</p>
				</li>
				<li>
					<p>14:45 Dott. Paolo Amato <br> 
						Micron Technology Inc. <br>
						<a href="../../../../assets/eventi/2018/Milano/Slide_PaoloAmato.pdf">
							The Challenges of Memory and Storage Security</a>
					</p>
				</li>
			</ul>
		</li>
		<li><p><b>15:00 - 15:30 Coffe Break</b></p></li>
		<li><p><b>15:30 - 16:45  Sessione IV</b></p>
			<ul class="ulSon">
				<li>
					<p>15:30 Dott. Andrea Barri <br>
						SAP <br>
						<a href="../../../../assets/eventi/2018/Milano/Slide_SAP_AndreaBarri.pdf">
							Un caso d'uso: l'Intelligent Blockchain per le imprese visionarie </a>
					</p>
				</li>
				<li>
					<p>15:45 Dott. Massimo Iaccarino <br>
						Eurizon Asset Management <br>
						<a>Come utilizzare un DLT Private nei processi di riconciliazione 
							di portafogli</a>
					</p></li>
				<li>
					<p>16:00 Dott. Hannes Eder <br>
						Google Zurich <br>
						<a href="../../../../assets/eventi/2018/Milano/Kanagala.pdf">High Availability 
							in the Internal Google Key Management System</a>
					</p>
				</li>
				<li>
					<p>16:15 Dott.ssa Silvia Mella<br>
						ST Microelectronics <br>
						<a href="">Security Challenges in the IoT</a>
					</p>
				</li>
				<li>
					<p>16:30 Dott. Luigi Pugnetti <br> 
						Symbolic<br>
						<a href="../../../../assets/eventi/2018/Milano/Slide_Symbolic_LuigiPugnetti.pdf">
							Network Security a 360°</a>
					</p></li>
			</ul>
		</li>
		<li><p><b>16:45 - 17:30 Questions & Answers, Closing Remarks, Networking</b></p></li>
	</ul>
	<hr>
	<p> Questo evento è stato coordinato a livello nazionale dall'Acting Director 
		della De Componendis Cifris e a livello locale dal Comitato De Cifris, rappresentato da:
	</p>
	<p>
		Prof. Alberto Leporati (Chair) - <b>Università degli Studi di Milano-Bicocca</b> - Dipartimento di Informatica, Sistemistica e Comunicazione (DISCo); <br>
	  	Prof.ssa Francesca Dalla Volta - <b>Università degli Studi di Milano-Bicocca</b> - Dipartimento di Matematica e Applicazioni; <br>
		Dott. Andrea Visconti - <b>Università degli Studi di Milano</b> - Dipartimento di Informatica (DI); <br>
		Dott. Ottavio Giulio Rizzo - <b>Università degli Studi di Milano</b> - Dipartimento di Matematica; <br>
		Prof. Gerardo Pelosi - <b>Politecnico di Milano</b> - Dipartimento di Elettronica, Informazione e Bioingegneria (DEIB); <br>
		Dott. Alessandro Barenghi - <b>Politecnico di Milano</b> - Dipartimento di Elettronica e Informazione (DEI).
	</p>
</div>
  